import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { CustomerRow } from '@cdw-ae/common-data';
import type { ICdwSearchGridDataService } from '@cdw-ae/common-ui-components-search-grid';
import type {
  IGetSqlDataParams,
  SqlResponse,
} from '@cdw-ae/filter-bar-interfaces';
import type { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

/**
 * SSRM data source for the customers grid. The grid calls `fetchSqlData` per
 * row block; we forward the filter/sort/window to the server-side search
 * endpoint. The platform-auth interceptor attaches the Bearer token.
 */
@Injectable({ providedIn: 'root' })
export class CustomersDataService
  implements ICdwSearchGridDataService<CustomerRow>
{
  private readonly http = inject(HttpClient);

  fetchSqlData(params: IGetSqlDataParams): Observable<SqlResponse<CustomerRow>> {
    const { activeFilters, supplementalFilters, startRow, endRow, sortOrder } =
      params;
    return this.http.post<SqlResponse<CustomerRow>>(
      `${environment.urls.backendApi}/platform/customers/search`,
      { activeFilters, supplementalFilters, startRow, endRow, sortOrder }
    );
  }
}
